import React, { useState, useMemo, useEffect } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../apiClient";
import { checkPermissionExist, getPlaceholderName } from "../../utils/general";
import { RESOURCE_VIEW_PERMISSION, SUBGROUP_VIEW_PERMISSION } from "../../constant/permission";


const { useUnoSelector } = UnoStoreHooks;

const CustomSearch = () => {
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [groupsList, setGroupsList] = useState([]);
  const [usersList, setUsersList] = useState([]);

  const getGroupUsersList = async () => {
    try {
      setIsLoading(true)
      let list = await apiClient.get(`${configData.config.UNO_URL}/api/group/hierarchy/group/user/list/${userData.user.group.uuid}`, {
        params: {
          limit: 10,
          search: searchQuery || null,
        },
      });
      setGroupsList(list?.groupsList || [])
      setUsersList(list?.usersList || [])
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchQuery.trim().length > 0) {
        getGroupUsersList();
      } else if (searchQuery.trim().length === 0) {
        setGroupsList([]);
        setUsersList([]);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);


  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
  };

  const handleSearchBlur = () => {
    setTimeout(() => setIsSearchFocused(false), 200);
  };

  const handleResultClick = (type, item) => {
    if (type === "group") {
      navigate(`/team-management/${item.uuid}`);
    } else if (type === "user") {
      navigate(`/team-management/user/${item.uuid}`);
    }
  };


  return (
    <>
      <div className="customSearchWrapper">
        <div className={`search-bar ${isSearchFocused ? "searchActive" : ""}`}>
          <input
            type="text"
            className="form-control"
            autoComplete="off"
            placeholder="Search users and groups..."
            value={searchQuery}
            onChange={(e) => handleSearchChange(e.target.value)}
            onFocus={handleSearchFocus}
            onBlur={handleSearchBlur}
          />
          {/* <span className="search-btn">
            {isLoading ? (
              <div className="loading-dot"></div>
            ) : (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M19 19L12.95 12.95M12.95 12.95C13.6003 12.3001 14.1161 11.5285 14.4678 10.6791C14.8196 9.8297 15.0004 8.91933 15 8C15 4.13 11.866 1 8 1C4.134 1 1 4.13 1 8C1 11.87 4.134 15 8 15C9.933 15 11.683 14.22 12.95 12.95Z"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span> */}

          {isSearchFocused && (
            <div className="searchResultBox">
              <div className={`searchResultArea ${isLoading ? "loading" : ""}`}>
                {searchQuery.trim().length === 0 ?
                  <EmptyState />
                  :
                  isLoading ?
                    <LoadingSpinner />
                    :
                    (usersList.length === 0 && groupsList.length === 0) ?
                      <NoResults query={searchQuery} />
                      :
                      <>
                        {usersList.length > 0 && checkPermissionExist(RESOURCE_VIEW_PERMISSION) &&
                          <div className="resultType">
                            <h6>Users ({usersList.length})</h6>
                            <div className="resultList">
                              {usersList.map((user) => (
                                <div
                                  key={user.uuid}
                                  className="resultItem"
                                  onClick={() => handleResultClick("user", user)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span className="thumb">
                                    {user.avatar ? (
                                      <img src={user.avatar} referrerPolicy="no-referrer" alt={user.name} />
                                    ) : (
                                      <span className="initials">{getPlaceholderName(user.name)}</span>
                                    )}
                                  </span>
                                  <div className="infoHere">
                                    <div className="name-detail">
                                      <p>{user.name}</p>
                                      <span className="groupTitle">{user?.group?.name || ""}</span>
                                    </div>
                                    
                                    {/* <p>{user.email || user.uid}</p> */}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        }

                        {groupsList.length > 0 && checkPermissionExist(SUBGROUP_VIEW_PERMISSION) && (
                          <div className="resultType groups">
                            <h6>Groups ({groupsList.length})</h6>
                            <div className="resultList">
                              {groupsList.map((group) => (
                                <div
                                  key={group.id}
                                  className="resultItem"
                                  onClick={() => handleResultClick("group", group)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span className="thumb">
                                    {group.avatar ? (
                                      <img src={group.avatar} referrerPolicy="no-referrer" alt={group.name} />
                                    ) : (
                                      <span className="initials">{getPlaceholderName(group.name)}</span>
                                    )}
                                  </span>
                                  <div className="infoHere">
                                    <div className="name-detail">
                                      <p>{group.name}</p>
                                      <span className="groupTitle">{group.type.name}</span>
                                    </div>
                                    {/* <p>{group.stats}</p> */}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                }
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};


const EmptyState = () => (
  <div className="empty-state">
    <div className="empty-icon">👥</div>
    <h6>Start searching</h6>
    <p>Search for users and groups to get started</p>
  </div>
);


// Loading component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Searching...</p>
  </div>
);

// No results component
const NoResults = ({ query }) => (
  <div className="no-results">
    <div className="no-results-icon">🔍</div>
    <h6>No results found</h6>
    <p>We couldn't find any matches for "{query}"</p>
    <div className="search-tips">
      <p>Try:</p>
      <ul>
        <li>• Checking your spelling</li>
        <li>• Using different keywords</li>
        <li>• Searching for partial names</li>
      </ul>
    </div>
  </div>
);

export default CustomSearch;
